import { apiErrorMessageForUser } from './apiErrorMessage';

const payloadMessage = (payload) => {
    return apiErrorMessageForUser(payload);
};

export const expectExactPayload = (payload, expected, operation) => {
    if (payload !== expected) {
        throw new Error(
            payloadMessage(payload) || `${operation} returned an unexpected response.`
        );
    }

    return payload;
};

export const expectArrayPayload = (payload, operation) => {
    if (!Array.isArray(payload)) {
        throw new Error(
            payloadMessage(payload) || `${operation} returned an unexpected response.`
        );
    }

    return payload;
};

export const requestErrorMessage = (error, fallback) => {
    const responseMessage = payloadMessage(error?.response?.data);
    if (responseMessage) return responseMessage;

    return apiErrorMessageForUser(error?.message, fallback);
};
